<div class="dialog-loading" *ngIf="(loading$ | async)">
    <mat-spinner diameter="36"></mat-spinner>
</div>

<div class="dialog-title-content">
    <div class="dialog-title">{{'common.dialog.listDialog.title.' + data.itemsType | translate}}</div>
    <div class="dialog-close" (click)="closeDialog(false)">
        <mat-icon>close</mat-icon>
    </div>
</div>
<div class="dialog-content no-overflow">
    <form class="dialog-table-filter" [formGroup]="filterForm" *ngIf="canSearchItem">
        <div class="filter-field-wrapper" *ngIf="!data.searchDisabled">
            <mat-form-field floatLabel="auto" class="full-width no-top-margin" style="width: 300px; min-width: 300px; max-width: 300px">
                <input type="text" matInput formControlName="keyWord"
                       placeholder="{{'common.dialog.listDialog.placeholders.' + data.itemsType | translate}}">
            </mat-form-field>
            <button style="top: 10px" type="button" class="clear-button clear-field" *ngIf="getRequestQuery()?.keyWord" (click)="filterForm.get('keyWord')?.reset()">
                <mat-icon>close</mat-icon>
            </button>
        </div>

        <div class="filter-field-wrapper" *ngIf="data.selector">
            <mat-form-field floatLabel="auto" class="full-width no-top-margin" style="width: 250px; min-width: 250px; max-width: 250px" *ngIf="data.selector">
                <mat-select class="select-panel" panelClass="dialog-select-panel" disableOptionCentering="true" formControlName="selector"
                            placeholder="{{data.selector?.translation + '.null' | translate}}">
                    <mat-option *ngFor="let selectorOption of data.selector?.options" [value]="selectorOption">
                        {{data.selector?.translation + '.' + selectorOption | translate}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <button style="top: 10px" type="button" class="clear-button clear-field" *ngIf="getRequestQuery()?.selector != undefined" (click)="filterForm.get('selector')?.reset()">
                <mat-icon>close</mat-icon>
            </button>
        </div>

        <div class="df grow jc-e ai-c" *ngIf="canAddItem">
            <div class="action-button green" (click)="addEditItem()">
                <mat-icon class="action-button-icon">playlist_add</mat-icon>
                <span>{{'common.addItem' | translate}}</span>
            </div>
        </div>
    </form>

    <div class="df gap20 jc-s ai-c" *ngIf="data.itemsType === 'LEAD' && !data.searchDisabled" style="min-height: 60px">
        <app-user-filter [formControl]="manager" (ngModelChange)="loadLeadsList()"></app-user-filter>
        <button class="action-button gray" [disabled]="!manager?.value?.id" (click)="manager.setValue(null)">
            <mat-icon class="action-button-icon">clear</mat-icon>
        </button>
    </div>

    <div class="empty-block df-c gap15" *ngIf="!dataSource?.data?.length && (loading$ | async) === false">
        <mat-icon>search</mat-icon>
        <span>{{'common.commonEmpty' | translate}}</span>
    </div>

    <div class="table-container full-height" *ngIf="dataSource && dataSource.data && dataSource.data.length && (loading$ | async) === false">
        <ng-container *ngIf="data.itemsType === 'LEAD'">
            <mat-table [dataSource]="dataSource" class="dialog-table">
                <ng-container matColumnDef="contact">
                    <mat-header-cell *matHeaderCellDef class="grow">{{'modules.crm.contacts.list.table.contact' | translate}}</mat-header-cell>
                    <mat-cell *matCellDef="let element" class="grow df-c jc-c ai-s" style="gap: 2px;">
                        <app-user-item
                                [userName]="(element.contact?.lastName ? element.contact?.lastName : '') + (element.contact?.lastName && element.contact?.firstName ? ' ' : '') + (element.contact?.firstName ? element.contact?.firstName : '') +  (!element.contact?.lastName && !element.contact?.firstName ? ('modules.clients.users.list.noUserName' | translate) : '')"
                                [userParentalName]="element.contact.parentalName ? element.contact.parentalName : ''"
                                [phones]="element.contact.phones"
                                [avatarLink]="element.contact.userAvatarLink?.replace('s0', 's64-c')"
                                [canCall]="true"
                        ></app-user-item>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="type">
                    <mat-header-cell *matHeaderCellDef class="grow">{{'modules.crm.contacts.list.table.type' | translate}}</mat-header-cell>
                    <mat-cell *matCellDef="let element" class="grow df-c jc-c ai-s" style="gap: 2px;">
                        {{element.contact.type ? ('modules.crm.contacts.types.' + element.contact.type | translate) : ''}}
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="manager">
                    <mat-header-cell *matHeaderCellDef class="grow">{{'modules.crm.contacts.list.table.manager' | translate}}</mat-header-cell>
                    <mat-cell *matCellDef="let element" class="grow df-c jc-c ai-s" style="gap: 2px;">
                        {{element.manager?.name ? element.manager?.name : ('modules.crm.contacts.list.table.managerEmpty' | translate)}}
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="creationDate">
                    <mat-header-cell *matHeaderCellDef class="grow">{{'modules.crm.contacts.list.table.creationDate' | translate}}</mat-header-cell>
                    <mat-cell *matCellDef="let element" class="grow df-c jc-c ai-s" style="gap: 2px;">
                        {{element.contact.creationDate | date: 'dd.MM.yyyy'}}
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="actions">
                    <mat-header-cell *matHeaderCellDef style="width: 120px; min-width: 120px; max-width: 120px">{{'common.tableActionsColumn' | translate}}</mat-header-cell>
                    <mat-cell *matCellDef="let element" style="width: 120px; min-width: 120px; max-width: 120px" class="df gap5">

                        <button class="item-action-button gray" (click)="upsertContact(element.contact); $event.stopPropagation()">
                            <mat-icon>visibility</mat-icon>
                        </button>

                        <button class="item-action-button gray" (click)="selectItem(true, element); $event.stopPropagation()">
                            <mat-icon style="font-weight: 700">add_task</mat-icon>
                        </button>
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="columns; sticky: true" class="list-table-header"></mat-header-row>
                <mat-row *matRowDef="let row; columns: columns" class="list-table-row selectable" (click)="selectItem(true, row)"></mat-row>
            </mat-table>
        </ng-container>
        <ng-container *ngIf="data.itemsType === 'TASK'">
            <mat-table [dataSource]="dataSource" class="dialog-table">

                <ng-container matColumnDef="dateTime">
                    <mat-header-cell *matHeaderCellDef style="width: 180px; min-width: 180px; max-width: 180px">{{'Дата час'}}</mat-header-cell>
                    <mat-cell *matCellDef="let element" style="width: 180px; min-width: 180px; max-width: 180px" class="clickable" (click)="selectItem(true, element)">
                        <div class="df-c gap5">
                            <span>{{element.date | date: 'dd.MM.yyyy'}} {{element.time ? element.time: '--:--'}}</span>
                            <span>{{'modules.crm.leads.taskStatuses.' + element.status | translate}}</span>
                        </div>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="manager">
                    <mat-header-cell *matHeaderCellDef style="width: 200px; min-width: 200px; max-width: 200px">{{'Виконавець'}}</mat-header-cell>
                    <mat-cell *matCellDef="let element" style="width: 200px; min-width: 200px; max-width: 200px" class="clickable" (click)="selectItem(true, element)">
                        {{element?.manager?.name ? element?.manager?.name : ''}}
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="taskType">
                    <mat-header-cell *matHeaderCellDef style="width: 200px; min-width: 200px; max-width: 200px">{{'Тип завдання'}}</mat-header-cell>
                    <mat-cell *matCellDef="let element" style="width: 200px; min-width: 200px; max-width: 200px" class="clickable" (click)="selectItem(true, element)">
                        {{element.type ? ('modules.crm.leads.taskTypes.' + element.type | translate) : ''}}
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="analytic">
                    <mat-header-cell *matHeaderCellDef class="grow">{{'Аналітика'}}</mat-header-cell>
                    <mat-cell *matCellDef="let element" class="clickable grow" (click)="selectItem(true, element)">
                        <div class="df-c gap5">
                            <span *ngIf="element.project?.name">Проект: {{element.project?.name}}</span>
                            <span *ngIf="element.contact?.id">Контакт: {{element.contact?.lastName}} {{element.contact?.firstName}}</span>
                        </div>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="actions">
                    <mat-header-cell *matHeaderCellDef style="width: 120px; min-width: 120px; max-width: 120px">{{'common.tableActionsColumn' | translate}}</mat-header-cell>
                    <mat-cell *matCellDef="let element" style="width: 120px; min-width: 120px; max-width: 120px" class="df gap5">
                        <button class="item-action-button gray" (click)="addEditItem(element)" *ngIf="canEditItem">
                            <mat-icon>edit_note</mat-icon>
                        </button>
                        <button class="item-action-button gray" (click)="deleteItem(element)" *ngIf="canDeleteItem">
                            <mat-icon>delete_outline</mat-icon>
                        </button>
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="columns; sticky: true" class="list-table-header"></mat-header-row>
                <mat-row *matRowDef="let row; columns: columns" class="list-table-row"></mat-row>
            </mat-table>
        </ng-container>
        <ng-container *ngIf="data.itemsType !== 'LEAD' && data.itemsType !== 'TASK'">
            <mat-table [dataSource]="dataSource" class="dialog-table">
                <ng-container *ngFor="let column of columns; let i = index" matColumnDef="{{column}}">
                    <mat-header-cell *matHeaderCellDef class="{{columnStyles[i]}}" [ngClass]="{'actions-header-multiple': column === 'actions' && multiple}">
                        <div class="df ai-c gap10" *ngIf="column === 'actions' && multiple">
                            <button class="action-button green" *ngIf="selectedItems.length" (click)="confirmSelection(); $event.stopPropagation()">
                                <span>Додати ({{selectedItems.length}})</span>
                            </button>
                            <mat-checkbox [checked]="allVisibleSelected"
                                          (change)="toggleSelectAll()"
                                          (click)="$event.stopPropagation()"
                            ></mat-checkbox>
                        </div>
                        <ng-container *ngIf="column !== 'actions' || !multiple">
                            {{'common.dialog.listDialog.labels.' + data.itemsType + '.' + column | translate}}
                        </ng-container>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let object" [ngClass]="{'inactive': object.archived}" class="{{columnStyles[i]}}">
                        <span *ngIf="column !== 'actions' && column !== 'amount' && column !== 'handled' && column !== 'uncovered'" (click)="multiple ? toggleSelectItem(object) : selectItem(true, object)">
                            {{columnTranslations[i] && columnTranslations[i].length
                            ?
                            (object[column] ? (columnTranslations[i] + '.' + object[column] | translate) : '')
                            : object[column] && object[column].name ? object[column].name : object[column]}}
                        </span>
                        <span *ngIf="column === 'amount' || column === 'handled' || column === 'uncovered'"
                              (click)="multiple ? toggleSelectItem(object) : selectItem(true, object)"
                              [ngClass]="{'error': (column == 'handled' && object['handled'] != object['amount'])
                                                || (column == 'uncovered' && object['uncovered'] > 0)}"
                        >
                            {{object[column] | currency: 'UAH':'грн.':'0.2-2'}}
                        </span>
                        <div class="grow df gap5 jc-e ai-c" *ngIf="column === 'actions'">
                            <mat-checkbox *ngIf="multiple"
                                          [checked]="isItemSelected(object)"
                                          (change)="toggleSelectItem(object)"
                                          (click)="$event.stopPropagation()"
                            ></mat-checkbox>
                            <button class="item-action-button gray" (click)="openItem(object)" *ngIf="canOpenItem">
                                <mat-icon>visibility</mat-icon>
                            </button>
                            <button class="item-action-button gray" (click)="addEditItem(object)" *ngIf="canEditItem">
                                <mat-icon>edit_note</mat-icon>
                            </button>
                            <button class="item-action-button gray" (click)="deleteItem(object)" *ngIf="canDeleteItem">
                                <mat-icon>delete_outline</mat-icon>
                            </button>
                        </div>
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="columns; sticky: true" class="list-table-header"></mat-header-row>
                <mat-row *matRowDef="let row; columns: columns" class="list-table-row selectable"></mat-row>
            </mat-table>
        </ng-container>
    </div>
    <mat-paginator
            class="dialog-table-paginator"
            [length]="pagination?.totalElements"
            [pageIndex]="pagination?.number"
            [pageSize]="pagination?.size"
            [pageSizeOptions]="pageSizeOptions"
            (page)="changePage($event)"
    ></mat-paginator>
</div>
